import Breadcrumb from "../components/Breadcrumb";
import CustomerProfiles from "../components/CustomerProfile";

const CustomerProfilePage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Customer Profile" />

      {/*clients roles page*/}
      <CustomerProfiles />
    </>
  );
};

export default CustomerProfilePage;
